export const NotFound = ()=>{
    return (
    <div className="container">
        <div className="not-found">
            <h2>page not found</h2>
        </div>
    </div>
    )
}